import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="currentColor"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5.712 12.274a.75.75 0 0 0 .75-.75V7.678l7.205 7.205a.75.75 0 1 0 1.06-1.06L7.522 6.616h3.847a.75.75 0 0 0 0-1.5H4.962v6.407c0 .414.336.75.75.75Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBack;
